// extracted by mini-css-extract-plugin
export default {"VisualisationHeader":"VisualisationBlock_VisualisationHeader__LGuFM","Title":"VisualisationBlock_Title__jDGRw","EditButton":"VisualisationBlock_EditButton__acynj"};